import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Slide, toast } from 'react-toastify';
import FontIcomoonIcon from '../FontIcomoonIcon';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';

@withI18next()
class TimeDownload extends React.Component {
  componentDidMount() {
    const { t, date } = this.props;
    if (date === 0) {
      return null;
    }
    const diff = moment().diff(moment.unix(date), 'd');
    if (diff > 1) return null;
    const time = moment.unix(date).fromNow(true);

    const icon = (
      <FontIcomoonIcon
        style={{ fontSize: 20 }}
        icon="icon-clock-circular-outline"
        fixedWidth
      />
    );
    const Description = () => (
      <div className="statistics-content">
        {icon}
        <strong style={{ margin: '0 3px 0 5px' }}>{time}</strong>
        {t(`${Config.getPrefixContent('beforeDownload')}`)}
      </div>
    );

    if (process.browser) {
      setTimeout(() => {
        if (toast.isActive('toast.time-download')) return;
        toast(<Description />, {
          autoClose: 8000,
          position: toast.POSITION.BOTTOM_RIGHT,
          toastId: 'toast.time-download',
          className: 'layout-toast-info',
          transition: Slide,
        });
      }, 2000);
    }
  }

  render() {
    return null;
  }
}

TimeDownload.propTypes = {
  date: PropTypes.any,
};
TimeDownload.defaultProps = {
  date: '',
};
export default TimeDownload;
